import { createReducer, on } from '@ngrx/store';

import * as SpacesActions from './spaces.actions';

export interface SpacesState {
  spaces: any[];
}

export const initialState: SpacesState = {
  spaces: [],
};

export const reducer = createReducer(
  initialState,
  on(SpacesActions.loadSpacesSuccess, (state, { spaces }) => ({
    ...state,
    spaces,
  }))
);
